var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationMark = function SvgExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.398 10.91-.389-5.816Q.9 3.394.9 2.654q0-1.008.523-1.567.535-.57 1.396-.57 1.045 0 1.396.728.353.717.353 2.076 0 .801-.085 1.627l-.523 5.986q-.084 1.069-.364 1.639t-.922.57q-.657 0-.911-.546-.255-.559-.364-1.687m1.347 7.988q-.74 0-1.299-.473Q.9 17.939.9 17.077q0-.753.522-1.275.535-.534 1.3-.534.764 0 1.298.534.547.524.547 1.275 0 .85-.547 1.336-.546.485-1.275.485"
  })));
};
export default SvgExclamationMark;